import PropTypes from 'prop-types';

export const SvgStringToHtml = ({ className, svgString }) => (
  <div
    className={className}
    dangerouslySetInnerHTML={{ __html: svgString }}
  />
);

SvgStringToHtml.propTypes = {
  className: PropTypes.string,
  svgString: PropTypes.string.isRequired,
};

SvgStringToHtml.defaultProps = {
  className: '',
};
